<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout justify-center>
        <v-flex xs12 sm10 md8 lg6>
          <v-card v-if="!confirmScreen">
            <!-- <v-card-title>Enter information to be included in the directory</v-card-title> -->
            <v-toolbar dark color="primary">
              <v-toolbar-title>Enter information to be included in the directory</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-btn class="ma-2" color="warning" @click="instructions = !instructions">
                Read me first!
              </v-btn>
              <v-expand-transition>
                <v-card v-show="instructions" class="mx-auto">
                  <v-card-text>
                    <p>Thank you for using the Southview Online Student Directory!  It is an easy way to get the contact info of other parents for birthday parties, play dates, or other events.</p>
                    <p>Here are the steps to get started:
                      <ol>
                        <li>Enter your student's information first (name, grade, teacher). 
                          <ul>
                            <li>You can add more than one student at a time just by clicking the "Add Student" button again.</li>
                            <li>This information helps fill out the class lists in the directory.</li>
                          </ul>
                        </li>
                        <li>Enter your contact information.  
                          <ul>
                            <li>Only share the information you feel comfortable with.</li>
                            <li>You can add more than one parent at a time just by clicking the "Add Parent/Guardian" button again.</li>
                            <li>Check the "Use as Student Address" box to have your address info show up for your students in the directory listing.</li>
                          </ul>
                        </li>
                        <li>Sign Up for an Account to access the directory.
                          <ul>
                            <li>We take keeping personal address information secure to only Southview community members seriously.  
                              In order to lookup information in the directory please click the "Sign Up" button on the login page.</li>

                          </ul>

                        </li>
                      </ol>
                    </p>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
              <v-form v-model="valid">
                <h3>Add your Students here:</h3>
                <v-layout wrap>
                  <v-flex pa-1 v-for="(student, index) in students" :key="`student-${index}`">
                    <v-card>
                      <v-card-text>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="student.first" name="first" label="First Name" type="text" :rules="[rules.required]" required></v-text-field></v-flex>
                            <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="student.last" name="last" label="Last Name" type="text" :rules="[rules.required]" required></v-text-field></v-flex>
                            <v-flex xs12 sm10 md8 lg6 pa-1><v-select :items="grades" v-model="student.grade" name="grade" label="Grade" :rules="[rules.required]" required></v-select></v-flex>
                            <v-flex xs12 sm10 md8 lg6 pa-1><v-select v-model="student.teacher" :items="getTeachers(student.grade)" name="teacher" label="Teacher" :rules="[rules.required]"></v-select></v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-btn text color="primary" @click="addStudentRow">
                  <v-icon dark>add</v-icon> Add Student
                </v-btn>

                <h3>Add Parents/Guardians Contact Info here:</h3>
                <v-layout wrap>
                  <v-flex pa-1 v-for="(parent, index) in parents_guardians" :key="`parent-${index}`">
                    <v-card >
                      <v-card-text>
                        <v-layout align-center justify-center row wrap>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.name" label="Name" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.phone" label="Phone Number" v-mask="phoneMask" :hint="phoneMask" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.email" label="Email" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.address" name="address" label="Address" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.city" name="city" label="City" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-text-field v-model="parent.zip" name="zip" label="Zip" type="text"></v-text-field></v-flex>
                          <v-flex xs12 sm10 md8 lg6 pa-1><v-checkbox v-model="parent.isPrimary" label="Use as Student Address"></v-checkbox></v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-btn text color="primary" @click="addParentRow">
                  <v-icon dark>add</v-icon> Add Parent/Guardian
                </v-btn>
               
              
              </v-form>
            </v-card-text>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
             
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid || students.length === 0" color="primary" @click="showPopup = true">Confirm</v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-if="confirmScreen">
            <v-card-title>
              Thank you!
            </v-card-title>
            <v-card-text>
              <div>Thank you for submitting information to the directory.</div>
              <v-spacer></v-spacer>
              <div v-for="(result, index) in submitResults" :key="`submitResult-${index}`">
                <v-icon v-if="result.success" color="green">check_circle</v-icon>
                <v-icon v-if="!result.success" color="orange">warning</v-icon>
                <span>{{result.message}}</span>
              </div>
              <v-spacer></v-spacer>
              <div>If you have not already go to the <router-link to="/">home page</router-link> to sign up for access.</div> 
            </v-card-text>
          </v-card>
          <v-dialog v-model="showPopup" max-width="800">
            
                <v-card>
                  <v-card-title class="headline grey lighten-2">{{popupTitle}}</v-card-title>
                  <v-card-text>
                    <div v-if="!submitting">
                    Please confirm the information you are submitting to the directory:
                                <v-divider class="mt-5"></v-divider>

                    <h4>Students</h4>
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th class="text-left">First</th>
                            <th class="text-left">Last</th>
                            <th class="text-left">Grade</th>
                            <th class="text-left">Teacher</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(student, index) in students" :key="`student-confirm-${index}`">
                            <td>{{ student.first }}</td>
                            <td>{{ student.last}}</td>
                            <td>{{ student.grade}}</td>
                            <td>{{ student.teacher }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                                  <v-divider class="mt-5"></v-divider>

                      <h4>Parents / Guardians</h4>
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Phone</th>
                            <th class="text-left">Email</th>
                            <th class="text-left">Address</th>
                            <th class="text-left">City</th>
                            <th class="text-left">Zip</th>
                            <th class="text-left">Use For Student</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(parent, index) in parents_guardians" :key="`parent-confirm-${index}`">
                            <td>{{ parent.name }}</td>
                            <td>{{ parent.phone}}</td>
                            <td>{{ parent.email}}</td>
                            <td>{{ parent.address}}</td>
                            <td>{{ parent.city}}</td>
                            <td>{{ parent.zip}}</td>
                            <td>{{ parent.isPrimary}}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    
                    </div>
                    <v-progress-circular
                      :size="50"
                      color="primary"
                      indeterminate v-if="submitting"
                    ></v-progress-circular>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click="showPopup = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green" text @click="submit">Submit</v-btn>                    
                  </v-card-actions>
                </v-card>
           
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import firebase from 'firebase';
import { mask } from 'vue-the-mask';

const axios = require('axios');

export default {
  name: 'AddStudent',
  directives: {
    mask
  },
  data () {
    return {
      parents_guardians: [],
      students: [],
      teacherMap: {},
      grades:['K','1','2','3','4','5'],
      showPopup: false,
      submitting: false,
      confirmScreen: false,
      popupTitle: 'Confirm Information',
      submitError: false,
      submitResults:[],
      valid: false,
      instructions: false,
      phoneMask: "###-###-####",
      rules: {
        required: (value) => {
          let valid = !!value;
          return valid || 'Required.';
        },
      }
    }
  },
  mounted() {
    console.log('Route: ', this.$route);
    //load teachers for dropdown from firebase
    firebase.firestore().collection('admin').doc('teachers').get().then((doc) => {
      console.log('Teachers:', doc.data());
      this.teacherMap = doc.data();
    });
    
  },
  computed: {

  },
  methods: {
      addParentRow() {
        this.parents_guardians.push({name:'', phone:'', email:'', address:'', city:'', zip:'', isPrimary:false})
      },
      addStudentRow() {
        this.students.push({first:'', last:'', grade:'', teacher:'', home_phone: ''})
      },
      getTeachers(grade) {
        if(!grade) {
          return [];
        }
        else {
          return this.teacherMap[grade];
        }

      },
      submit () {
        this.submitting = true;
        this.popupTitle = "Submitting information....";
        let payload = {
          parents_guardians: this.parents_guardians,
          students: this.students
        };
        console.log('Submitting data: ', payload);
        axios.post(process.env.VUE_APP_ADD_STUDENT_ENDPOINT, payload).then((resp) => {
          console.log('Response: ', resp)
          //success, close modal
          this.showPopup = false;
          this.submitting = false;
          this.confirmScreen = true;
          this.submitResults = resp.data.ops;
        }).catch((err) => {
          console.log(` error:`, err);
          this.showPopup = false;
          this.submitting = false;
        });
    },
    resultIcon(success) {
      return (success ? 'check': 'alert');
    }
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
